import { render } from "./TheKyThiHSG.vue?vue&type=template&id=7a87a184"
import script from "./TheKyThiHSG.vue?vue&type=script&lang=js"
export * from "./TheKyThiHSG.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__